'use strict';

var formHelpers = require('./util/formErrors');

function findPosition (obj) {
    var currenttop = $('.header')[0].offsetHeight;
    if (obj.offsetTop) {
        currenttop = obj.offsetTop - currenttop;
        return [currenttop];
    }
}

function updateCharactersLabel(event) {
    /**
     * Count the number of characters typed.
     */
    var element = event.target ? event.target : event;
    const typedCharacters = element.value.length;
    const maxLenght = element.attributes['maxlength'].value;

    if (typedCharacters > maxLenght) {
        event.preventDefault();
    }else{
        let subText = $('.left-char');
        subText.each(function (item) {
            subText[item].innerText = maxLenght - typedCharacters;
        });
    }
}

function resetCareersForm($form){
    var textArea = $form.find('#message')[0];
    var attachmentBtn = $form.find('.attachment-load-button');

    $form[0].reset()
    updateCharactersLabel(textArea);

    $form.find('[class$="valid-label"]').removeClass (function (index, className) {
        return className.match(/\S+(valid-label)/g);
    });
    $form.find('[class$="valid-input"]').removeClass (function (index, className) {
        return className.match(/\S+(valid-input)/g);
    });
    $form.parsley().reset();

    $('.success-load-msg').remove();
    attachmentBtn.find('.delete-file').removeClass('show');
    attachmentBtn.find('.load-file').show();
    attachmentBtn.find('.file-name')[0].innerText = null;
}

class CareersCV {
    constructor() {
        this.closeform = $('.careers-form-header .close-button');
        this.accordion = $('.careers-icon.accordion');

        this.careersForm = $('.careers-form');

        this.textAreaElement = $('.careers-form #message');
        this.attachmentInput = $('.careers-form #attachment');
        this.attachmentBtn = $('.attachment-load-button');

        this.profilingLabel = $('.careers-form #profiling').parent();
    }

    run() {
        var form = this.careersForm;

        $(document).ready(() => {
            this.careers();
            this.dimensionFileControl();
            this.typingControl();
            this.attachmentValidation();
            this.profilingValidation();
            this.formVisibility();
            this.deleteFile();
        });

        const googleRecaptchaClientSide = document.querySelector('input[name="googleRecaptchaClientSide"]');
        if (googleRecaptchaClientSide) {
            grecaptcha.ready(function () {
                grecaptcha.execute(googleRecaptchaClientSide.value, { action: 'submit' }).then(function (token) {
                    form.prepend(`<input type="hidden" name="googleRecaptchaToken" value="${token}">`);
                    form.prepend('<input type="hidden" name="googleRecaptchaAction" value="newsletter_form">');
                });
                setInterval(function () {
                    grecaptcha.execute(googleRecaptchaClientSide.value, { action: 'submit' }).then(function (token) {
                        $('input[name=googleRecaptchaToken]').val(token);
                    });
                }, 90000); // tokens gets marked as expired after 2 mins https://github.com/google/recaptcha/issues/302
            });
        }
    }

    deleteFile(){
        let attachmentInput = this.attachmentInput[0];
        let attachmentBtn = this.attachmentBtn;

        $('.delete-file').on('click', function () {
            attachmentInput.value = '';
            attachmentBtn.find('.file-name')[0].innerText = null;

            $('.success-load-msg').remove();
            $('.delete-file').removeClass('show');
            $('.load-file').show();
        });
    }

    formVisibility() {
        var $form = this.careersForm;

        this.accordion.add(this.closeform).on('click', function (){
            let arrow = $('.careers-icon.accordion .arrow');
            let formContainer = $('.careers-form-container');

            if(arrow.hasClass('down')){
                formContainer.show();
                arrow.removeClass('down');
                arrow.addClass('up');
                window.scrollTo({
                    top: findPosition(formContainer[0]),
                    behavior: 'smooth',
                })

            }else{
                formContainer.hide();
                arrow.removeClass('up');
                arrow.addClass('down');
                resetCareersForm($form);
            }
        });
    }

    attachmentValidation(){

        const attachmentInput = this.attachmentInput;
        var successMsgText = attachmentInput.attr('data-load-success-message');
        var attachment_label = $('.attachment-header label');
        var attachmentBtn = this.attachmentBtn;
        var attachmentBtnParent = attachmentBtn.parent();

        // create an observer instance
        var observer = new MutationObserver(function(mutations) {
            if(mutations.length > 0){

                if(attachmentInput.hasClass('is-invalid-input')){

                    var errorField = attachmentInput.siblings('.errors-list');
                    attachment_label.removeClass('is-valid-label');
                    attachmentBtn.removeClass('is-valid-input');
                    attachment_label.addClass('is-invalid-label');
                    attachmentBtn.addClass('is-invalid-input');
                    attachmentInput.removeClass('is-valid-input');
                    $('.success-load-msg').remove();

                    if(attachmentBtnParent.find('.errors-list').length > 0 && errorField.length > 0){
                        attachmentBtnParent.find('.errors-list').remove();
                    }

                    attachmentBtnParent.append(errorField);
                    attachmentInput[0].value = ''; //to delete the file in filelist

                }else if(attachmentInput.hasClass('is-valid-input')){

                    attachment_label.removeClass('is-invalid-label');
                    attachmentBtn.removeClass('is-invalid-input');
                    attachment_label.addClass('is-valid-label');
                    attachmentBtn.addClass('is-valid-input');
                    attachmentInput.removeClass('is-invalid-input');

                    const successMsg = `<div class="success-load-msg"><span>${successMsgText}</span></div>`;
                    attachmentBtn.parent().append(successMsg);

                    $('.attachment-group .errors-list').remove();
                    attachmentBtn.find('.load-file').hide();
                    attachmentBtn.find('.delete-file').addClass('show');

                }else{
                    attachment_label.removeClass('is-invalid-label');
                    attachmentBtn.removeClass('is-invalid-input');
                    attachment_label.addClass('is-valid-label');
                    attachmentBtn.addClass('is-valid-input');
                    $('.attachment-group .errors-list').remove();
                }
            }
        });

        var config = { attributes: true, childList: true, characterData: true };

        observer.observe(attachmentInput[0], config);

    }

    profilingValidation(){

        const profilingLabel = this.profilingLabel;
        var profilingContent = profilingLabel.siblings('.privacy-content-asset');
        
        // create an observer instance
        var observer = new MutationObserver(function(mutations) {
            if(mutations.length > 0){

                if(profilingLabel.hasClass('is-invalid-input')){
                    profilingContent.addClass('is-invalid-input');
                }else if(profilingLabel.hasClass('is-valid-input')){
                    profilingContent.removeClass('is-invalid-input');
                }
            }
        });

        var config = { attributes: true, childList: true, characterData: true };

        observer.observe(profilingLabel[0], config);

    }

    typingControl(){
        const messageArea = this.textAreaElement;
        this.textAreaElement.on("keyup", (event) => {
            const emojisRegExp = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
            messageArea.val(messageArea.val().replace(/\n/g,"").replace(new RegExp(emojisRegExp), ''));
            updateCharactersLabel(event);
        });
    }

    dimensionFileControl(){

        const attachmentInput = this.attachmentInput;
        var attachmentBtn = this.attachmentBtn;

        attachmentInput.on('change', (event) => {
            const target = event.target
            if (target.files && target.files[0]) {

                let button = this.careersForm.find('button');
                $(button).attr('disabled', false);

                /*Maximum allowed size in bytes
                  1MB Example
                  Change first operand(multiplier) for your needs*/
                var sizeData = Math.floor($(target).attr('data-max-size'));
                var maxAllowedSize = Number(sizeData + '000000' ) ; //to convert in MB the number setted in custom preference

                $('.attachment-group .errors-list').remove();

                var fileExtension = ['pdf'];
                if ($.inArray(target.files[0].name.split('.').pop().toLowerCase(), fileExtension) >= 0) {
                    if (target.files[0].size > maxAllowedSize) {

                        const $label = $('.attachment-header label');
                        const errorMsg = `<div class="errors-list filled"><span class="form-error is-visible">${$(target).attr('data-size-error-message')}</span></div>`;
                        $(target).addClass('is-invalid-input');

                        $label.addClass('is-invalid-label');
                        attachmentBtn.parent().append(errorMsg);
                        attachmentBtn.find('.load-file').show();
                        attachmentBtn.find('.delete-file').removeClass('show');

                    }else{
                        attachmentBtn.find('.file-name')[0].innerText = target.files[0].name;
                        attachmentInput.removeClass('is-invalid-input');
                        attachmentBtn.find('.load-file').hide();
                        attachmentBtn.find('.delete-file').addClass('show');
                    }
                }else{
                    const $label = $('.attachment-header label');
                    const errorMsg = `<div class="errors-list filled"><span class="form-error is-visible">${$(target).attr('data-extension-error-message')}</span></div>`;
                    $(target).addClass('is-invalid-input');

                    $label.addClass('is-invalid-label');
                    attachmentBtn.parent().append(errorMsg);
                    attachmentBtn.find('.load-file').show();
                    attachmentBtn.find('.delete-file').removeClass('show');
                }
            }else{
                attachmentBtn.find('.file-name')[0].innerText = null;
            }

        })
    }

    careers() {
        var form = this.careersForm;
        var closeBtn = this.closeform;

        this.careersForm.submit(function (e) {
            e.preventDefault();

            const $form = $(e.currentTarget);
            var submitBtn = form.find('button.submit');
            var url = form.attr('action');

            submitBtn.find('.submit-text').css('opacity', '0');
            submitBtn.find('.loader').addClass('show');

            $.ajax({
                url: url,
                type: 'POST',
                crossDomain: true,
                data: new FormData(this),
                dataType: "json",
                processData: false,
                contentType: false,
                headers: {
                    "Accept": "application/json"
                },
                success: function (data) {

                    // reload recaptcha
                    const googleRecaptchaClientSide = document.querySelector('input[name="googleRecaptchaClientSide"]');
                    if (googleRecaptchaClientSide) {
                        grecaptcha.execute(googleRecaptchaClientSide.value, { action: 'submit' }).then(function (token) {
                            $('input[name=googleRecaptchaToken]').val(token);
                        });
                    }

                    setTimeout(function () {
                        var errors = 0;

                        if(data.errorFields){
                            for (var key in data.errorFields) {
                                if (data.errorFields.hasOwnProperty(key)) errors++;
                            }
                        }

                        if (errors > 0 && !data.success) {

                            submitBtn.attr('disabled', false);
                            formHelpers.loadFormErrors($form, data.errorFields);

                            var markedinvalid = $('.is-invalid-input');
                            if (markedinvalid.length > 0) {
                                $([document.documentElement, document.body]).animate({
                                    scrollTop: markedinvalid.offset().top - 100
                                }, 1000);
                            }

                            submitBtn.find('.loader').removeClass('show');
                            submitBtn.find('.submit-text').css('opacity', '1');

                        } else {

                            submitBtn.find('.loader').removeClass('show');
                            submitBtn.find('.success-check').addClass('show');
                            submitBtn.addClass('success-submit');

                            setTimeout(function () {
                                closeBtn.trigger('click');
                                submitBtn.find('.success-check').removeClass('show');
                                submitBtn.removeClass('success-submit');
                                submitBtn.find('.submit-text').css('opacity', '1');

                                window.scrollTo(0, 0);

                                let popupSuccess = $('.careers-popup-body-success');
                                popupSuccess.addClass('show');

                                setTimeout(function () {
                                    popupSuccess.removeClass('show');
                                }, 6000);

                            }, 3000);
                        }
                    }, 2000);
                },
                error: function (err) {
                    closeBtn.trigger('click');
                    submitBtn.find('.loader').removeClass('show');
                    submitBtn.find('.submit-text').css('opacity', '1');

                    window.scrollTo(0, 0);
                    let popupError = $('.careers-popup-body-error');

                    popupError.addClass('show');
                    setTimeout(function () {
                        popupError.removeClass('show');
                    }, 6000);
                }
            });
            return false;
        });
    }
}

const careersCV = new CareersCV();
careersCV.run();



// WEBPACK FOOTER //
// ./assets/scripts/careersCV.js